import { ArrowRight } from "lucide-react";
import { useState, type FormEvent } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth } from "../lib/auth-context";

export function LoginPage() {
  const { session, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (session) return <Navigate to={session.needsGoal ? "/onboarding/goal" : "/earn"} replace />;
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const next = await login(email, password);
      const from = (location.state as { from?: string } | null)?.from;
      navigate(next.needsGoal ? "/onboarding/goal" : from || "/earn", { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Unable to sign in.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="auth-page">
      <div className="auth-top"><Logo to="/" /></div>
      <section className="auth-card">
        <p className="eyebrow">WELCOME BACK</p><h1>Keep moving toward your goal.</h1><p>Sign in to see your balance, activity, and best next offer.</p>
        <form onSubmit={submit}>
          <label>Email address<input type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          <label>Password<input type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} /></label>
          <Link className="forgot-link" to="/forgot-password">Forgot password?</Link>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="button" disabled={busy}>{busy ? "Signing in…" : "Sign in"}<ArrowRight /></button>
        </form>
        <p className="auth-switch">New to Bucks? <Link to="/">Create a free account</Link></p>
      </section>
    </main>
  );
}
